import $ from 'jQuery';

const $window = $(window);
const debounceDelay = 250;
const breakpoint_md_max = 991;

function initialScroll() {
    var windowWidth = $window.outerWidth();
    if (windowWidth > breakpoint_md_max) {
        doParallaxScroll();
    }
}

function toggleScroll() {
    var windowWidth = $window.outerWidth();
    if (windowWidth > breakpoint_md_max) {
        $window.on('scroll', doParallaxScroll);

        let timeout = false;
        $window.on('resize', function () {
            clearTimeout(timeout);
            timeout = setTimeout(doParallaxScroll, debounceDelay);
        });
    } else {
        $window.off('scroll', doParallaxScroll);
        $window.off('resize', doParallaxScroll);
    }
}

function visible(element) {
    var rect = element.getBoundingClientRect();

    if (rect.height <= 0) return false;
    if (rect.width <= 0) return false;
    if (rect.bottom < 0) return false;
    if (rect.right < 0) return false;
    if (rect.top > (window.innerHeight || document.documentElement.clientHeight)) return false;
    if (rect.left > (window.innerWidth || document.documentElement.clientWidth)) return false;
    return true;
}

function parallaxScroll(parallaxElement) {
    var distanceToTop = $window.scrollTop();
    var paralaxElementDistanceToTop = $(parallaxElement).offset().top;
    var paralaxElementHeight = $(parallaxElement).height();

    if (visible(parallaxElement)) {
        var scrollDiff = distanceToTop - paralaxElementDistanceToTop;
        var ratio = Math.round((scrollDiff / paralaxElementHeight) * 100);
        $(parallaxElement).css({
            'background-position': 'center ' + parseInt(-ratio * 1.5) + 'px',
        });
    }
}

function doParallaxScroll() {
    parallaxScroll($('.my-dotations__bg_image')[0]);
}

$(function () {
    if ($('.my-dotations__bg_image')[0] != undefined) {
        initialScroll();
        toggleScroll();
        $window.on('resize', toggleScroll);
    }
});
